export default "/images/b359d34f907d50f163880e4708561704.avif";